import { MatDialogRef } from '@angular/material/dialog';
import { PartnerListSearchCriteria, PartnerSearchCriteria } from '../models';
import { ExportDialogComponent } from '../../../../../ui-kit';

export class PartnerListLoad {
  public static readonly type = '[PartnerList] Load';

  constructor(public payload: PartnerSearchCriteria | PartnerListSearchCriteria) {}
}

export class PartnerListInitialState {
  public static readonly type = '[PartnerList] Set initial state';
}

export class PartnerListExportToFileStart {
  public static readonly type = '[PartnerListExport] start';

  constructor(
    public payload: {
      name: string;
      filterView: Partial<PartnerListSearchCriteria>;
      dialogRef: MatDialogRef<ExportDialogComponent>;
      navigationNeeded: boolean;
    },
  ) {}
}

export class PartnerListLoadByFilter {
  public static readonly type = '[PartnerList] LoadByFilter';

  constructor(public payload: PartnerListSearchCriteria) {}
}
